interface Props {
  courseIn: string;
  courseOut: string;
  className?: string;
}

export const RateDisplay: React.FC<Props> = ({ courseIn, courseOut,className}) =>{
  return (
    <div className={className}>
      <div className={"flex flex-col text-sm"}>
        <div className="flex justify-between gap-x-4">
          <div className="font-klein font-medium text-main-black dark:text-white min-w-[81px]">
            Входящие:
          </div>
          <div className="font-klein flex-1 font-medium text-main-black dark:text-white">
            1 USDT = {courseIn}
          </div>
        </div>
        <div className="flex justify-between gap-x-4">
          <div className="font-klein font-medium text-main-black dark:text-white min-w-[81px]">
            Исходящие:
          </div>
          <div className="font-klein flex-1 font-medium text-main-black dark:text-white">
            1 USDT = {courseOut}
          </div>
        </div>
      </div>
    </div>
  )
}